import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import SiteFooter from '../components/SiteFooter';
import { trackPageVisit } from '../services/visitAnalyticsService';
import { DEFAULT_LOCALE, isLocale, localeBase } from './publicPaths';

const PublicLocaleLayout = () => {
  const { locale } = useParams();
  const { i18n } = useTranslation();
  const location = useLocation();
  const valid = isLocale(locale);
  const lng = valid ? locale : DEFAULT_LOCALE;
  const dir = lng === 'ar' ? 'rtl' : 'ltr';

  useEffect(() => {
    if (!valid) return;
    document.documentElement.setAttribute('dir', dir);
    document.documentElement.setAttribute('lang', lng);
    if (!i18n.language?.startsWith(lng)) {
      i18n.changeLanguage(lng);
    }
  }, [dir, i18n, lng, valid]);

  useEffect(() => {
    if (!valid) return;
    trackPageVisit(location.pathname);
  }, [location.pathname, valid]);

  if (!valid) {
    return <Navigate to={localeBase(DEFAULT_LOCALE)} replace />;
  }

  return (
    <>
      <Helmet>
        <html lang={lng} dir={dir} />
      </Helmet>
      <Outlet />
      <SiteFooter />
    </>
  );
};

export default PublicLocaleLayout;
